import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Mutation } from 'react-apollo';

import mutations from '../../../graphql/mutations';

import { validateEmail, formatErrors } from '../../../helpers';

import { AuthConsumer } from '../../../context/auth';

import style from './index.module.scss';

const {
  authMutations: { LOGIN },
} = mutations;

class LoginForm extends Component {
  state = {
    email: '',
    password: '',
    errors: [],
  };

  onChange = e =>
    this.setState({
      [e.target.name]: e.target.value,
    });

  onFormValidation = () => {
    const { email, password, errors } = this.state;

    if (email && validateEmail(email) && password) {
      return true;
    }

    this.setState({
      errors: [],
    });

    if (!this.email) {
      this.setState({
        errors: errors.push('Please enter email address'),
      });
    } else if (!validateEmail(email)) {
      this.setState({
        errors: errors.push('Invalid email entry'),
      });
    }

    if (!this.password) {
      this.setState({
        errors: errors.push('Password is a required field'),
      });
    }
  };

  onLogin = async (e, loginUser, handleAuthentication) => {
    // this.onFormValidation();

    e.preventDefault();

    const { email, password, errors } = this.state;

    if (errors.length === 0) {
      const { data: { loginUser: { user, token } } } = await loginUser({
        variables: {
          input: { email: email.trim(), password: password.trim() },
        },
      });

      if (token && user) {
        handleAuthentication(true, user);

        localStorage.setItem('quora-token', token);
        localStorage.setItem('current-user', JSON.stringify(user));

        this.setState({
          email: '',
          password: '',
          errors: [],
        });
      }
    }
  };

  render() {
    const { email, password, errors } = this.state;

    const { pathname } = this.props.location;

    return (
      <div className={style.login}>
        <p className={style['login-heading']}>Login</p>
        <Mutation mutation={LOGIN}>
          {(loginUser, { loading, error }) => (
            <AuthConsumer>
              {({ handleAuthentication }) => (
                <form
                  className={style['login-form']}
                  onSubmit={e =>
                    this.onLogin(
                      e,
                      loginUser,
                      handleAuthentication,
                      error,
                    )
                  }
                >
                  <input
                    className={`form-control ${style['form-control']}`}
                    type='email'
                    name='email'
                    value={email}
                    placeholder='Email'
                    onChange={this.onChange}
                  />
                  <input
                    className={`form-control ${style['form-control']}`}
                    type='password'
                    name='password'
                    value={password}
                    placeholder='Password'
                    onChange={this.onChange}
                  />
                  {error && (
                    <>
                      {formatErrors(error.graphQLErrors).map(
                        (errorMsg, index) => (
                          <p key={index} className={style['error-msg']}>
                            {errorMsg}
                          </p>
                        )
                      )}
                    </>
                  )}
                  <button
                    className={`btn btn-primary ${style.btn} ${
                      style['btn-primary']
                    }`}
                    disabled={errors.length > 0}
                  >
                    {loading ? <i className='fas fa-spinner' /> : 'Login'}
                  </button>
                </form>
              )}
            </AuthConsumer>
          )}
        </Mutation>
        <br />
        {pathname !== '/' && (
          <p className={style['signup-prompt']}>
            Don't have an account? <Link to='/auth'>Sign up</Link>
          </p>
        )}
      </div>
    );
  }
}

export default withRouter(LoginForm);
